import React, { Component } from 'react';
import Reflux from 'reflux';

class PanelFooter extends Component {
  render() {
    return (
      <div className="border-t py-2 px-3 font-medium flex justify-between items-center bg-gray-100">
        {this.props.children}
      </div>
    );
  }
}

export { PanelFooter };
